import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { colors } from "@/theme";

export function Spinner({ full = false }) {
  const s = (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 48 }}>
      <div
        style={{
          width: 34, height: 34, borderRadius: 999, border: `2.5px solid ${colors.surfaceTertiary}`,
          borderTopColor: colors.brand, animation: "spin 0.8s linear infinite",
        }}
      />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
  if (full) return <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>{s}</div>;
  return s;
}

export function SectionTitle({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div style={{ textAlign: align, marginBottom: 20 }}>
      {eyebrow && <div className="eyebrow" style={{ marginBottom: 8 }}>{eyebrow}</div>}
      <h2 className="font-display" style={{ margin: 0, fontSize: 30, lineHeight: 1.15, fontWeight: 700, color: colors.onSurface }}>{title}</h2>
      {subtitle && <p className="font-body" style={{ margin: "8px 0 0", color: colors.mutedText, fontSize: 15 }}>{subtitle}</p>}
    </div>
  );
}

export function EmptyState({ title, message, action }) {
  return (
    <div style={{ textAlign: "center", padding: "72px 24px" }}>
      <h3 className="font-display" style={{ fontSize: 26, fontWeight: 700, margin: 0 }}>{title}</h3>
      {message && <p className="font-body" style={{ color: colors.mutedText, marginTop: 10, fontSize: 15 }}>{message}</p>}
      {action && <div style={{ marginTop: 22 }}>{action}</div>}
    </div>
  );
}

export function ProductGridSkeleton({ count = 8 }) {
  return (
    <div className="product-grid">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i}>
          <div className="skeleton" style={{ aspectRatio: "3 / 4" }} />
          <div className="skeleton" style={{ height: 14, marginTop: 12, width: "80%" }} />
          <div className="skeleton" style={{ height: 14, marginTop: 8, width: "40%" }} />
        </div>
      ))}
    </div>
  );
}

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Spinner full />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Spinner full />;
  if (!user || user.role !== "admin") return <Navigate to="/login" replace />;
  return children;
}
